<div class="dialog-content-wrapper-contact">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Nuevo Contacto</span>
      <button
        mat-icon-button
        (click)="matDialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <form [formGroup]="rform" (ngSubmit)="onSubmit($event)">
    <div mat-dialog-content class="content-detail">
      <div class="content-detail__info">
        <div
          class="content-detail__info__room"
          *ngIf="data.persistType === 'single'">
          Sala actual:
          <span
            class="content-detail__info__room content-detail__info__room--room-name"
            >{{ data['room'].name }}</span
          >
        </div>
        <span class="content-detail__info__leyend field-leyend"
          >( * ) campos requeridos</span
        >
      </div>

      <div class="content-detail__row">
        <div class="content-detail__column">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Nombre *</mat-label>
            <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
            <input type="text" name="name" matInput formControlName="firstName" />
            <mat-error
              *ngIf="f.get('firstName').invalid || f.get('firstName').dirty">
              <span *ngIf="f.get('firstName').errors?.required">{{
                errorMessage()
              }}</span>
              <span *ngIf="f.get('firstName').errors?.maxlength"
                >{{ 'MAX_LENGTH_FIELDS' | translate }}: {{ maxLengthFields }}</span
              >
            </mat-error>
          </mat-form-field>
        </div>
        <div class="content-detail__column">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Apellido *</mat-label>
            <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
            <input type="text" name="apellido" matInput formControlName="lastName" />
            <mat-error *ngIf="f.get('lastName').invalid || f.get('lastName').dirty">
              <span *ngIf="f.get('lastName').errors?.required">{{
                errorMessage()
              }}</span>
              <span *ngIf="f.get('lastName').errors?.maxlength"
                >{{ 'MAX_LENGTH_FIELDS' | translate }}: {{ maxLengthFields }}</span
              >
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="content-detail__row">
        <div class="content-detail__column">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{ lblEmail }}</mat-label>
            <mat-icon matSuffix class="secondary-text">mail_outline</mat-icon>
            <input type="text" name="correo" matInput formControlName="email" />
            <mat-error *ngIf="f.get('email').invalid || f.get('email').dirty">
              <span *ngIf="f.get('email').errors?.required">{{
                errorMessage()
              }}</span>
              <span *ngIf="f.get('email').errors?.pattern">Correo invalido</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="content-detail__column">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Alias</mat-label>
            <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
            <input name="alias" matInput matInput formControlName="alias" />
            <mat-error *ngIf="f.get('alias').invalid || f.get('alias').dirty">
              <span *ngIf="f.get('alias').errors?.maxlength"
                >{{ 'MAX_LENGTH_FIELDS' | translate }}: {{ maxLengthFields }}</span
              >
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="content-detail__row">
        <div class="content-detail__column">
          <div class="inputs-wrapper">
            <mat-label
              class="label-phone custom-lbl"
              [class.disabled]="disabledPhone"
              >{{ lblPhone }}:</mat-label
            >
            <div class="inputs-groups">
              <mat-form-field
                appearance="outline"
                class="inputs-groups__field inputs-groups__field--country">
                <mat-label>País</mat-label>
                <input
                  type="text"
                  formControlName="countryCode"
                  matInput
                  [matAutocomplete]="autoCountry" />
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoCountry="matAutocomplete">
                  <mat-option
                    *ngFor="let option of countryCodeOptions | async"
                    [value]="option.valueMap"
                    (onSelectionChange)="onSelectedCountryCode($event, option)">
                    {{ option.valueMap }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <!-- <mat-form-field appearance="outline"
                                class="inputs-groups__field inputs-groups__field--area">
                                <mat-label>Área</mat-label>
                                <input type="text" name="area" matInput formControlName="areaPhone"
                                    oninput="this.value=this.value.replace(/[^\d]/,'')" maxlength="4">
                            </mat-form-field> -->
              <mat-form-field
                appearance="outline"
                class="inputs-groups__field inputs-groups__field--number">
                <mat-label>Número</mat-label>
                <mat-icon matSuffix class="secondary-text">phone</mat-icon>
                <input
                  type="text"
                  name="numero"
                  matInput
                  formControlName="phone"
                  oninput="this.value = this.value.replace(/[^\d]/, '')"
                  maxlength="15" />
              </mat-form-field>
            </div>
          </div>

          <div class="phone__error">
            <mat-error>
              <ng-container
                *ngIf="
                  f.get('countryCode')?.touched ||
                  f.get('areaPhone')?.touched ||
                  f.get('phone')?.touched
                ">
                <span
                  *ngIf="
                    f.get('countryCode').errors?.required ||
                    f.get('areaPhone').errors?.required ||
                    f.get('phone').errors?.required
                  "
                  >{{ errorMessage() }}</span
                >
              </ng-container>
              <!-- <span *ngIf="isExistPhone">El número se encuentra en uso</span> -->
              <span *ngIf="isCountrCodeBad">Selecciona un código de pais</span>
              <span *ngIf="isWrongCountryCodeOption">Ingrese un código válido</span>
              <span *ngIf="isPhoneMaxLengthBad"
                >El número debe tener
                {{ selectedCountryCode.length || '0' }} digitos</span
              >
            </mat-error>
          </div>
        </div>

        <div class="content-detail__column">
          <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Empresa</mat-label>
              <mat-icon matSuffix class="secondary-text">business</mat-icon>
              <input
                type="text"
                formControlName="businessName"
                matInput
                [matAutocomplete]="auto" />
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option (click)="onCreateNewBusiness()" [value]="''">
                  <span fxLayoutAlign="center center"> + Agregar Empresa </span>
                </mat-option>
                <mat-option
                  *ngFor="let business of businessFilteredOptions | async"
                  [value]="business.name"
                  (onSelectionChange)="onSelecteBussines($event, business)">
                  {{ business.name }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="f.get('businessName').invalid || f.get('businessName').dirty">
                <span *ngIf="f.get('businessName').errors?.maxlength"
                  >{{ 'MAX_LENGTH_FIELDS' | translate }}: {{ maxLengthFields }}</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="content-detail__row" *ngIf="data.persistType === 'multiple'">
        <div class="content-detail__column">
          <div class="table-container">
            <mat-label class="label-mat-table custom-lbl">Crear en *: </mat-label>
            <div class="table-wrapper">
              <mat-table
                mat-table
                [dataSource]="dataSource"
                class="mat-table"
                fxFill>
                <!-- Room Column -->
                <ng-container matColumnDef="room">
                  <mat-header-cell
                    *matHeaderCellDef
                    style="color: #212121; font-size: 14px">
                    Salas
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{ row.room.name }} </mat-cell>
                </ng-container>

                <!-- Checkbox Column -->
                <ng-container matColumnDef="selected">
                  <mat-header-cell
                    mat-header-cell
                    *matHeaderCellDef
                    fxLayoutAlign="end center">
                    <span
                      style="color: #212121; padding-right: 5px; font-size: 14px">
                      Todo
                    </span>
                    <mat-checkbox
                      (change)="onSelectedRow($event, row, 'all', null)"
                      [formControl]="checkAllControl">
                    </mat-checkbox>
                  </mat-header-cell>
                  <mat-cell
                    mat-cell
                    *matCellDef="let row; let i = index"
                    fxLayoutAlign="end center">
                    <mat-checkbox
                      [id]="row.room.id"
                      [checked]="row.selected"
                      (change)="onSelectedRow($event, row, 'single', i)">
                    </mat-checkbox>
                  </mat-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="displayedColumns; sticky: true"
                  style="
                    min-height: 35px !important;
                    background-color: rgb(236, 236, 238);
                  ">
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"> </mat-row>
              </mat-table>
            </div>
          </div>
          <div class="table__error">
            <mat-error *ngIf="f.get('selectedRooms')?.touched">
              <span *ngIf="f.get('selectedRooms').errors?.required"
                >Selecciona al menos una sala</span
              >
            </mat-error>
          </div>
        </div>
      </div>
    </div>

    <div mat-dialog-actions class="mt-10 mat-dialog-actions">
      <button
        mat-raised-button
        type="button"
        class="mr-8"
        aria-label="cancel"
        style="background-color: #2d323e; color: white"
        (click)="matDialogRef.close()">
        {{ 'CANCEL' | translate }}
      </button>

      <button
        mat-raised-button
        type="submit"
        class="submit-button"
        color="accent"
        class="save-button"
        aria-label="SAVE"
        [disabled]="activeSpinner">
        <span style="display: flex; justify-content: center">
          <mat-spinner
            color="primary"
            diameter="30"
            style="top: 2px; position: absolute"
            *ngIf="activeSpinner">
          </mat-spinner>
        </span>
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </form>
</div>
